$(window).on("load", function () {
  if ($(".hero_slider")) {
    const hero_slider = new Swiper(".hero_slider", {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<img class="' +
            className +
            ' paginatioIcons" src="https://cdn.shopify.com/s/files/1/0776/5023/1526/files/skullEmoji.png?v=1762420820" />'
          );
        },
      },
      breakpoints: {
        // when window width is >= 1024px
        767: {
          slidesPerView: 1,
        },
      },
    });
  }
  if ($(".products_wrap")) {
    const allProductsWrap = document.querySelectorAll(".products_wrap");

    allProductsWrap.forEach((wrapper) => {
      const swiperEl = wrapper.querySelector(".products");
      const leftPagination = wrapper.querySelector(".pagination.left");
      const rightPagination = wrapper.querySelector(".pagination.right");

      new Swiper(swiperEl, {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        navigation: {
          nextEl: rightPagination,
          prevEl: leftPagination,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          // when window width is >= 640px
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          // when window width is >= 1024px
          1024: {
            slidesPerView: 3,
            spaceBetween: 35,
          },
        },
      });
    });
  }

  /** Function to add products to Cart */
window.addToCartWithProperties = async function (variantId, properties = {}, button = null) {
  try {
    let quantity = 1;

    // ✅ Try to find quantity near the clicked button (BEST)
    if (button) {
      const wrapper = button.closest('.info');
      const qtyInput = wrapper?.querySelector('.quantity__input');
      if (qtyInput) quantity = parseInt(qtyInput.value, 10) || 1;
    } 
    // 🔁 Fallback (single product page)
    else {
      const qtyInput = document.querySelector('.quantity__input');
      if (qtyInput) quantity = parseInt(qtyInput.value, 10) || 1;
    }

    const formData = {
      items: [
        {
          id: variantId,
          quantity: quantity, // ✅ FIXED
          properties: properties,
        },
      ],
    };

    console.log("Adding to cart:", formData);

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const result = await response.json();

    if (!response.ok) {
      console.error("Add to cart failed:", result);
      return;
    }

    // Update cart bubble
    const cartData = await fetch("/cart.js").then((r) => r.json());
    updateCartBubble(cartData.item_count);

    // Open cart drawer
    await updateCartDrawerAndOpen();

  } catch (error) {
    console.error("Error adding to cart:", error);
  }
};


// ----------------------------
// Update Cart Drawer and Open
// ----------------------------
async function updateCartDrawerAndOpen() {
  try {
    // Use the correct section URL format
    const response = await fetch('/cart?section_id=cart-drawer');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const text = await response.text();
    console.log("Cart drawer response received");
    
    const newDrawerHTML = new DOMParser().parseFromString(text, 'text/html');
    
    // Get the entire cart-drawer component, not just #CartDrawer
    const newCartDrawerComponent = newDrawerHTML.querySelector('cart-drawer');
    const currentCartDrawerComponent = document.querySelector('cart-drawer');

    if (newCartDrawerComponent && currentCartDrawerComponent) {
      // Replace the entire cart-drawer component, not just #CartDrawer
      currentCartDrawerComponent.replaceWith(newCartDrawerComponent);
      
      // Wait for DOM to update and reinitialize
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Now open the drawer using the new component
      const drawer = document.querySelector("cart-drawer");
      if (drawer) {
        // Force re-initialization by triggering the open method
        if (typeof drawer.open === "function") {
          // Find the cart link to pass as triggeredBy parameter
          const cartLink = document.querySelector('#cart-icon-bubble');
          drawer.open(cartLink);
        } else {
          drawer.classList.add("active");
          // Manually trigger the accessibility and focus trap
          manuallyOpenDrawer(drawer);
        }
      }
    }
  } catch (error) {
    console.error('Error updating cart drawer:', error);
    // Fallback: try alternative section URL
    await updateCartDrawerFallback();
  }
}

// ----------------------------
// Manual drawer opening (fallback)
// ----------------------------
function manuallyOpenDrawer(drawer) {
  // Replicate the open functionality from cart-drawer.js
  const cartDrawerNote = drawer.querySelector('[id^="Details-"] summary');
  if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
    // Re-set accessibility
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
  }
  
  // Add active class with animation
  setTimeout(() => {
    drawer.classList.add('animate', 'active');
  });

  // Set up focus trap
  const containerToTrapFocusOn = drawer.classList.contains('is-empty')
    ? drawer.querySelector('.drawer__inner-empty')
    : document.getElementById('CartDrawer');
  const focusElement = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
  
  if (containerToTrapFocusOn && focusElement) {
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  document.body.classList.add('overflow-hidden');
}

// ----------------------------
// Fallback Update Cart Drawer
// ----------------------------
async function updateCartDrawerFallback() {
  try {
    // Try alternative URL format
    const response = await fetch('/cart?view=drawer');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const text = await response.text();
    const newDrawerHTML = new DOMParser().parseFromString(text, 'text/html');
    const newCartDrawerComponent = newDrawerHTML.querySelector('cart-drawer');
    const currentCartDrawerComponent = document.querySelector('cart-drawer');

    if (newCartDrawerComponent && currentCartDrawerComponent) {
      currentCartDrawerComponent.replaceWith(newCartDrawerComponent);
      
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const drawer = document.querySelector("cart-drawer");
      if (drawer) {
        if (typeof drawer.open === "function") {
          const cartLink = document.querySelector('#cart-icon-bubble');
          drawer.open(cartLink);
        } else {
          drawer.classList.add("active");
          manuallyOpenDrawer(drawer);
        }
      }
    }
  } catch (error) {
    console.error('Fallback cart drawer update also failed:', error);
  }
}

// ----------------------------
// Update Cart Drawer (standalone - for other operations)
// ----------------------------
async function updateCartDrawer() {
  try {
    const response = await fetch('/cart?section_id=cart-drawer');
    
    if (!response.ok) {
      await updateCartDrawerFallback();
      return;
    }
    
    const text = await response.text();
    const newCartDrawerComponent = new DOMParser().parseFromString(text, 'text/html').querySelector('cart-drawer');
    const currentCartDrawerComponent = document.querySelector('cart-drawer');

    if (newCartDrawerComponent && currentCartDrawerComponent) {
      currentCartDrawerComponent.replaceWith(newCartDrawerComponent);
    }
  } catch (error) {
    console.error('Error updating cart drawer:', error);
    await updateCartDrawerFallback();
  }
}

// ----------------------------
// Update Cart Bubble
// ----------------------------
function updateCartBubble(cartCount) {
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (!cartIcon) return;

  let cartBubble = cartIcon.querySelector('.cart-count-bubble');

  if (cartCount > 0) {
    if (!cartBubble) {
      cartBubble = document.createElement('div');
      cartBubble.className = 'cart-count-bubble';
      cartIcon.appendChild(cartBubble);
    }
    cartBubble.innerHTML = `
      <span aria-hidden="true">( ${cartCount} )</span>
      <span class="visually-hidden">${cartCount} item${cartCount !== 1 ? 's' : ''}</span>
    `;
    cartBubble.style.display = 'block';
  } else if (cartBubble) {
    cartBubble.style.display = 'none';
  }
}

function changeMetaTitle() {
  const originalTitle = document.title;
  const awayTitle = "DEADASSCHEEZE! 💔";

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      // 🔥 Instant change when user leaves the tab
      document.title = awayTitle;
    } else {
      // 🔥 Restore instantly when user comes back
      document.title = originalTitle;
    }
  });
}
changeMetaTitle();
});
